import breakpoints from './breakpoints';
import colors from './colors';
import fonts from './fonts';
import mixins from './mixins';

const theme = {
  breakpoints,
  colors,
  fonts,
  mixins
};

export default theme;
